"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGleamWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GleamWrapperMixin = require("../../mixins/components/GleamWrapperMixin");
// TODO: In 9v, abstract to own component and directory
var StyledGleamWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledGleamWrapper",
  componentId: "c11n-8-107-0__sc-m5v26w-0"
})(["", ""], _GleamWrapperMixin.GleamWrapperMixin);
exports.StyledGleamWrapper = StyledGleamWrapper;